module.exports = __webpack_public_path__ + "static/media/2.937980c7.png";